module.exports = __webpack_public_path__ + "img/sulv_7.0bfaaf80.jpg";